module.exports = __webpack_public_path__ + "img/privacy_policy_intro.b0f4b35f.jpg";